import { supabase } from './supabase';

// Cache for maintenance status
let cachedStatus = null;
let cacheTimestamp = 0;
const CACHE_DURATION_MS = 60 * 1000; // 60 seconds

/**
 * Get maintenance status from Supabase with caching
 * Returns { enabled: boolean, message: string }
 * Fails open (returns enabled: false on any error)
 */
export async function getMaintenanceStatus(forceRefresh = false) {
  // Check for local override
  if (process.env.REACT_APP_MAINTENANCE_FORCE_ON === 'true') {
    return { enabled: true, message: 'Site is under maintenance. Please check back soon.' };
  }

  // Return cached value if still valid and not forcing refresh
  const now = Date.now();
  if (!forceRefresh && cachedStatus && (now - cacheTimestamp) < CACHE_DURATION_MS) {
    return cachedStatus;
  }

  try {
    const { data, error } = await supabase
      .from('app_settings')
      .select('value')
      .eq('key', 'maintenance')
      .single();

    if (error) {
      console.warn('Maintenance check failed (fail open):', error.message);
      // Fail open - allow site to work
      cachedStatus = { enabled: false, message: '' };
      cacheTimestamp = now;
      return cachedStatus;
    }

    const value = data?.value || {};
    cachedStatus = {
      enabled: Boolean(value.enabled),
      message: value.message || 'We\'re currently performing maintenance. Please check back soon.'
    };
    cacheTimestamp = now;
    return cachedStatus;
  } catch (err) {
    console.warn('Maintenance check error (fail open):', err);
    // Fail open
    cachedStatus = { enabled: false, message: '' };
    cacheTimestamp = now;
    return cachedStatus;
  }
}

/**
 * Force refresh and get maintenance status (for form submissions)
 */
export async function checkMaintenanceBeforeSubmit() {
  return getMaintenanceStatus(true);
}

/**
 * Clear the cache (useful for testing)
 */
export function clearMaintenanceCache() {
  cachedStatus = null;
  cacheTimestamp = 0;
}
